import React from 'react';
import ProductShowcase from '../components/ProductShowcase';

const Products = () => {
  return (
    <div className="page-container">
      <ProductShowcase />
    </div>
  );
};

export default Products; 